import { Paper, Stack } from '@mui/material';

import Loader from '../UI/loader/Loader';
import DomainControllerForm from './DomainControllerForm';
import LocalDomainsForm from './LocalDomainsForm';
import LocalDomainsTable from './LocalDomainsTable';
import DomainControllerTable from './DomainControllerTable';

import {
  useGetAuthenticationQuery,
  useGetDomainControllersQuery,
} from '../../services/ADapi';

const DomainControllers = () => {
  const {
    data: { user_id },
  } = useGetAuthenticationQuery();

  const { isLoading } = useGetDomainControllersQuery(user_id);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <Paper>
        <Stack sx={{ gap: 3, alignItems: 'flex-start' }}>
          <DomainControllerForm />
          <DomainControllerTable />
        </Stack>
      </Paper>
      <Paper>
        <Stack sx={{ gap: 3 }}>
          <LocalDomainsForm />
          <LocalDomainsTable />
        </Stack>
      </Paper>
    </>
  );
};

export default DomainControllers;
